/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AvatarSourceEnum = {
    Default: 'default',
    ThirdParty: 'thirdParty',
    User: 'user',
    Inherited: 'inherited',
    Unicode: 'unicode'
} as const;
export type AvatarSourceEnum = typeof AvatarSourceEnum[keyof typeof AvatarSourceEnum];


export function instanceOfAvatarSourceEnum(value: any): boolean {
    for (const key in AvatarSourceEnum) {
        if (Object.prototype.hasOwnProperty.call(AvatarSourceEnum, key)) {
            if (AvatarSourceEnum[key as keyof typeof AvatarSourceEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AvatarSourceEnumFromJSON(json: any): AvatarSourceEnum {
    return AvatarSourceEnumFromJSONTyped(json, false);
}

export function AvatarSourceEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvatarSourceEnum {
    return json as AvatarSourceEnum;
}

export function AvatarSourceEnumToJSON(value?: AvatarSourceEnum | null): any {
    return value as any;
}

